export const BLOCK_TIME = 2000;
export const SSP_USER_ID = 'sspUserId';
export const SSP_SESSION_ID = 'sspSessionId';
export const LAST_AD_SHOWN = 'lastShowTimestamp';
